import {Component, Inject} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {GlobalTrackingEventService, TrackedEvents} from "fello-common";
import {find} from "lodash-es";
import {FelloVisitorVariables} from "fello-model";

export interface HomeInfoField {
  name: string;
  value: number | null;
  min?: number | null;
  max?: number | null;
  icon: string;
  required: boolean;
}

@Component({
  selector: "app-que-home-info-update",
  templateUrl: "./que-home-info-update.component.html",
  styleUrls: ["./que-home-info-update.component.scss"]
})
export class QueHomeInfoUpdateComponent extends QuestionCardDirective {
  homeInfoFields: HomeInfoField[] = [
    {
      name: "Bedrooms",
      value: null,
      icon: "bedroom",
      max: 20,
      required: true
    },
    {
      name: "Full baths",
      value: null,
      icon: "bathroom",
      max: 20,
      required: true
    },
    {
      name: "Half baths",
      value: 0,
      icon: "half-bath",
      max: 20,
      required: true
    },
    {
      name: "Stories",
      value: null,
      icon: "stories-count",
      max: 100,
      required: true
    },
    {
      name: "Square feet",
      value: null,
      icon: "square-feet",
      max: 20000,
      required: true
    },
    {
      name: "Parking",
      value: null,
      icon: "parking-car-garage",
      max: 9,
      required: false
    },
    {
      name: "Year built",
      value: null,
      icon: "year-built",
      min: 1800,
      max: new Date().getFullYear(),
      required: true
    }
  ];
  showErrors = false;

  constructor(
    public offerJourneyService: OfferJourneyService,
    @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string,
    private globalTrackingEventService: GlobalTrackingEventService
  ) {
    super(offerJourneyService, taskId);
    this.offerJourney.vars.beds ? this.updateFieldValue("Bedrooms", this.offerJourney.vars.beds) : this.updateFieldValue("Bedrooms", null);
    this.offerJourney.vars.baths
      ? this.updateFieldValue("Full baths", this.offerJourney.vars.baths)
      : this.updateFieldValue("Full baths", null);
    this.offerJourney.vars.partialBaths
      ? this.updateFieldValue("Half baths", this.offerJourney.vars.partialBaths)
      : this.updateFieldValue("Half baths", 0);
    this.offerJourney.vars.sqft
      ? this.updateFieldValue("Square feet", this.offerJourney.vars.sqft)
      : this.updateFieldValue("Square feet", null);
    this.offerJourney.vars.storiesCount
      ? this.updateFieldValue("Stories", this.offerJourney.vars.storiesCount)
      : this.updateFieldValue("Stories", null);
    this.offerJourney.vars.parkingCount
      ? this.updateFieldValue("Parking", this.offerJourney.vars.parkingCount)
      : this.updateFieldValue("Parking", null);
    this.offerJourney.vars.yearBuilt
      ? this.updateFieldValue("Year built", this.offerJourney.vars.yearBuilt)
      : this.updateFieldValue("Year built", null);
  }

  updateFieldValue(fieldName: string, value: number | null): void {
    const field = find(this.homeInfoFields, {name: fieldName})!;
    field.value = value;
  }

  getFieldValue(fieldName: string): number | null {
    const field = find(this.homeInfoFields, {name: fieldName})!;
    return field.value;
  }

  next(): void {
    const vars: FelloVisitorVariables = {
      beds: this.getFieldValue("Bedrooms")!,
      baths: this.getFieldValue("Full baths")!,
      partialBaths: this.getFieldValue("Half baths")!,
      sqft: this.getFieldValue("Square feet")!,
      storiesCount: this.getFieldValue("Stories")!,
      parkingCount: this.getFieldValue("Parking")!,
      yearBuilt: this.getFieldValue("Year built")!
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe(() => {
      this.globalTrackingEventService.trackCustomEvent(TrackedEvents.HOME_FACTS_RECEIVED, {
        address: this.offerJourney?.vars?.address
      });
    });
  }
}
